import pako from 'pako'

export function decompressJson(data) {
  return JSON.parse(pako.inflate(data, { to: 'string' }))
}

export default {
  decompressJson,
}
